/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    UserRequest,
    UserRequestFromJSON,
    UserRequestToJSON,
} from './';

/**
 *
 * @export
 * @interface UserRequests
 */
export interface UserRequests {
    /**
     *
     * @type {Array<UserRequest>}
     * @memberof UserRequests
     */
    userRequests: UserRequest[];
    /**
     *
     * @type {boolean}
     * @memberof UserRequests
     */
    isNextPage: boolean;
}

export function UserRequestsFromJSON(json: any): UserRequests {
    return UserRequestsFromJSONTyped(json, false);
}

export function UserRequestsFromJSONTyped(json: any, _: boolean): UserRequests {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'userRequests': ((json['user_requests'] as any[]).map(UserRequestFromJSON)),
        'isNextPage': json['is_next_page'],
    };
}

export function UserRequestsToJSON(value?: UserRequests | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'user_requests': ((value.userRequests as any[]).map(UserRequestToJSON)),
        'is_next_page': value.isNextPage,
    };
}
